// client/src/components/notifications/RateLimitNotice.tsx
// 868mbzt38 — D3. Listens to the rate-limit gate and shows a single toast
// per activation. Lives next to other notification surfaces to keep the
// i18n provider and `useIntl` reach simple.

import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { onRateLimitActivated } from '@/lib/rateLimitGate';
import { showToast } from '@/lib/toast';

export function RateLimitNotice(): null {
  const intl = useIntl();

  useEffect(() => {
    const unsubscribe = onRateLimitActivated(() => {
      showToast.error(
        intl.formatMessage({ id: 'errors.http.tooManyRequests' }),
      );
    });
    return unsubscribe;
  }, [intl]);

  return null;
}
